import React, { PureComponent } from 'react';
import { Button, Grid, FormControl, Checkbox } from '@mui/material';
import { FaLock, FaLockOpen } from 'react-icons/fa';
import { SettingsAccessLevel } from '../../../types/types';

interface CoreEnforcementCheckboxProps {
  checked: boolean;
  onChange: (newValue: boolean) => void;
  elevatePermissions: () => void;
  accessLevel: SettingsAccessLevel;
}

export default class CoreEnforcementCheckbox extends PureComponent<CoreEnforcementCheckboxProps> {
  render() {
    return (
      <Grid>
        <FormControl>
          <Button style={{ marginRight: 10 }} variant="outlined" onClick={this.props.elevatePermissions}>
            {this.props.accessLevel === 'Locked' ? (
              <FaLock style={{ marginLeft: 7.5, marginRight: 7.5 }} />
            ) : (
              <FaLockOpen style={{ marginLeft: 7.5, marginRight: 7.5 }} />
            )}
            {this.props.accessLevel === 'Locked' ? 'Unlock' : 'Lock'}
          </Button>
        </FormControl>
        <FormControl variant="outlined">
          <div>
            <Checkbox
              checked={this.props.checked}
              onChange={(e) => this.props.onChange(e.target.checked)}
              disabled={this.props.accessLevel === 'Locked'}
            />
            Core Enforcement
          </div>
        </FormControl>
      </Grid>
    );
  }
}
